//get all defined properties (filters out null, undefined, ...)
export default object =>
  object &&
  Object.keys(object).reduce((defined, key) => {
    let value = object[key];
    if (value && value._id) {
      value = value._id;
    }

    if (value === false || value === 0 || (value && value !== '')) defined[key] = value;
    return defined;
  }, {});



// WEBPACK FOOTER //
// ./src/helpers/filterOutNotDefinedValues.js